export default "__VITE_ASSET__CEC5YjX5__"